import React from 'react';

import { makeStyles, Tooltip, Typography } from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

const useStyles = makeStyles(() => ({
  tooltipMessage: {
    color: '#FFF',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '23px',
  },
}));

export default ({ icon = <HelpOutlineIcon fontSize="small" color="inherit" />, color = 'inherit', message = '', placement = 'top' }) => {
  const classes = useStyles();

  return (
    <Tooltip interactive placement={placement} title={<Typography className={classes.tooltipMessage}>{message}</Typography>}>
      <span style={{ color }}>{icon}</span>
    </Tooltip>
  );
};
